import React, {useState, useEffect} from "react";
import { Button, InputLabel, Paper, TextField, Typography } from '@mui/material';
import { useAuth } from "../../Context/AuthContext";
import Alerta from "../../../components/Alerta";
import { db } from "../../../firebase/firebaseConfig";
import { collection, addDoc, doc, getDoc } from 'firebase/firestore';
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';

const FormularioCardCaracteristicasProducto = ({ infoCardCaracteristicaProductoSeleccionado }) => {
    const isItem = true;
    const [titulo, setTitulo] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const {usuario} = useAuth();
    const [estadoAlerta, setEstadoAlerta] = useState(false);
    const [alerta, setAlerta] = useState({});
    const [modoEdicion, setModoEdicion] = useState(false); // Variable de estado para el modo de edición
    const [imagen, setImagen] = useState(null); 

    useEffect(() => {
        const obtenerCardCaracteristicaProducto = async () => {
          if (!infoCardCaracteristicaProductoSeleccionado) return; // Asegúrate de que haya una vision seleccionada
          try {
            const cardCaracteristicaProductoDoc = await getDoc(doc(db, 'tarjetacaracteristicaproductocalocho', infoCardCaracteristicaProductoSeleccionado));
            if (cardCaracteristicaProductoDoc.exists()) {
                setModoEdicion(true);
                const cardCaracteristicaProductoData = cardCaracteristicaProductoDoc.data();
                setTitulo(cardCaracteristicaProductoData.titulo || '');
                setDescripcion(cardCaracteristicaProductoData.descripcion || '');
                setImagen(cardCaracteristicaProductoData.imagen || null);
            } else {
              console.log('No se encontró el documento');
              setModoEdicion(false);
            }
          } catch (error) {
            console.error('Error al obtener el documento:', error);
          }
        };
      
        obtenerCardCaracteristicaProducto();
    }, [infoCardCaracteristicaProductoSeleccionado]); // Asegúrate de que useEffect se ejecute cuando cambie infoCardCaracteristicaProductoSeleccionado
    
    const handleChange = (e) => {
        if(e.target.name === 'titulo'){
            setTitulo(e.target.value);
        } else if(e.target.name === 'descripcion'){
            setDescripcion(e.target.value);
        } else if (e.target.name === 'imagen') {
            const file = e.target.files[0];
            setImagen(file);
        }
    }

    const handleUpload = async (imagen) => {
        if (imagen) {
    
            try {
                const storageRef = getStorage(); // Obtener la instancia de almacenamiento
                const fileRef = ref(storageRef, `tarjetacaracteristicaproductocalocho/${imagen.name}`); // Obtener una referencia al archivo

                // Subir la imagen
                const snapshot = await uploadBytesResumable(fileRef, imagen);
                console.log('Imagen subida correctamente:', snapshot);
    
                // Obtener la URL de descarga
                const downloadURL = await getDownloadURL(snapshot.ref);
                console.log('URL de la imagen:', downloadURL);

                // Mostrar mensaje de éxito
                setEstadoAlerta(true);
                setAlerta({ tipo: 'exito', mensaje: 'Imagen subida correctamente' });
                
                // Devuelve la URL de la imagen
                return downloadURL;

            } catch (error) {
                console.error('Error al subir la imagen:', error);
                setEstadoAlerta(true);
                setAlerta({ tipo: 'error', mensaje: 'Error al subir la imagen' });
                return null;
            }
        } else {
            setEstadoAlerta(true);
            setAlerta({ tipo: 'error', mensaje: 'Por favor selecciona una imagen' });
            return null;
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        if (!imagen) {
            setEstadoAlerta(true);
            setAlerta({ tipo: 'error', mensaje: 'Por favor selecciona una imagen' });
            return;
        }
    
        try {
            const imageUrl = await handleUpload(imagen);

            if(modoEdicion && infoCardCaracteristicaProductoSeleccionado.id){

                // Cambiar el estado de modoEdicion a falso para volver al modo de creación
                setModoEdicion(false);
                
                // Limpiar el formulario después de agregar la vision
                setTitulo('');
                setDescripcion('');
                setImagen(null);
                infoCardCaracteristicaProductoSeleccionado('');
                // Mostrar mensaje de éxito
                setEstadoAlerta(true);
                setAlerta({ tipo: 'exito', mensaje: 'Visión actualizada correctamente' });
            
            } else {
                

                if(imageUrl){
                    // Agregar la visión a Firestore con la URL de la imagen
                    await addDoc(collection(db, 'tarjetacaracteristicaproductocalocho'), {
                        titulo: titulo,
                        descripcion: descripcion,
                        imagen: imageUrl, // URL de la imagen
                        uidUsuario: usuario.uid
                    });
    
                    // Limpiar el formulario después de agregar la visión
                    setTitulo('');
                    setDescripcion('');
                    setImagen(null);
    
                    // Mostrar mensaje de éxito
                    setEstadoAlerta(true);
                    setAlerta({ tipo: 'exito', mensaje: 'Visión agregada correctamente' });
                } else {
                    setEstadoAlerta(true);
                    setAlerta({ tipo: 'error', mensaje: 'Error al agregar la visión' });
                }
            }

            // Limpiar el formulario después de agregar la visión
            setTitulo('');
            setDescripcion('');
            setImagen(null);

        } catch (error) {
            console.error(error);
            setEstadoAlerta(true);
            setAlerta({ tipo: 'error', mensaje: 'Error al agregar la visión' });
        }
    }

    return(
        <Paper onSubmit={handleSubmit} component="form" sx={{ 
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '90%',
            maxWidth: '500px',
            margin: 'auto',
            padding: 2,
            boxShadow: 3,
            borderRadius: 2,
            gap: 2,
            // Añadimos media queries aquí
            '@media (max-width: 1024px)': { // Tablets
                width: '95%',  // Ocupar un poco más de ancho
                padding: 1,  // Reducir el padding
            },
            '@media (max-width: 600px)': {  // Móviles
                width: '100%',  // Ocupar todo el ancho
                padding: 1,  // Padding más pequeño
            },
         }}>
        <Typography variant='h5' sx={{ 
            width: 'auto',
            alignItems: 'center',
            textAlign: 'center',
            '@media (max-width: 600px)': {  // En móviles, reducir el tamaño del texto
                fontSize: '1.25rem',  // Ajustamos el tamaño de la fuente
            }
        }}>Card de los features</Typography>

            <TextField                  
                required
                size="small"
                id="titulo"
                fullWidth
                label="Título del visión"
                name="titulo"
                value={titulo}
                onChange={handleChange}
                />

            <TextField                  
                required
                size="small"
                fullWidth
                id="descripcion"
                multiline
                label="Descripción del visión"
                name="descripcion"
                value={descripcion}
                onChange={handleChange}/>

            <InputLabel id="img-label" sx={{ 
                width: 'auto',
                alignItems: 'center',
                textAlign: 'center'
            }}>Seleccione una imagen</InputLabel>
            <TextField                  
                fullWidth
                size="small"
                id="imagen"
                name="imagen"
                type='file'
                onChange={handleChange}
                inputProps={{ accept: 'image/*' }}/>

            <Button item={isItem.toString()} xs={12} sm={6}           
                type="submit"
                fullWidth
                size="small"
                variant="outlined"
            >{infoCardCaracteristicaProductoSeleccionado ? 'Editar visión' : 'Agregar visión'}</Button>
            <Alerta 
                tipo={alerta.tipo}
                mensaje={alerta.mensaje}
                estadoAlerta={estadoAlerta}
                setAlerta={setEstadoAlerta}
            />
        </Paper>

    );
}

export default FormularioCardCaracteristicasProducto;